import React, { useState, Fragment } from 'react';
import { Lock, TrendingUp, Target, Users, DollarSign, Zap, X, ChevronRight } from 'lucide-react';
export const InvestorLandingPage = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isBusinessCaseOpen, setIsBusinessCaseOpen] = useState(false);
  const handlePasswordSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Simple password check - in production, use proper authentication
    if (password === 'gigi2026') {
      setIsAuthenticated(true);
      setError('');
    } else {
      setError('Incorrect password');
    }
  };
  if (!isAuthenticated) {
    return <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4" data-id="element-858">
        <div className="max-w-md w-full" data-id="element-859">
          <div className="bg-white rounded-xl shadow-lg p-8" data-id="element-860">
            <div className="flex justify-center mb-6" data-id="element-861">
              <div className="w-16 h-16 bg-[#6366f1]/10 rounded-xl flex items-center justify-center" data-id="element-862">
                <Lock className="w-8 h-8 text-[#6366f1]" data-id="element-863" />
              </div>
            </div>
            <h2 className="text-2xl font-bold text-center text-gray-900 mb-2" data-id="element-864">
              Investor Access
            </h2>
            <p className="text-center text-gray-600 mb-6" data-id="element-865">
              Enter password to view Pre-Seed materials
            </p>
            <form onSubmit={handlePasswordSubmit} data-id="element-866">
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Enter password" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#6366f1] focus:border-transparent outline-none mb-4" data-id="element-867" />
              {error && <p className="text-red-600 text-sm mb-4 text-center" data-id="element-868">{error}</p>}
              <button type="submit" className="w-full py-3 bg-[#6366f1] text-white rounded-lg hover:bg-[#5457e5] font-semibold transition-colors" data-id="element-869">
                Access Materials
              </button>
            </form>
          </div>
        </div>
      </div>;
  }
  return <div className="min-h-screen bg-white" data-id="element-870">
      {/* Hero Section */}
      <section className="bg-gradient-to-b from-[#6366f1]/5 to-white pt-20 pb-16" data-id="element-871">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-872">
          <div className="text-center" data-id="element-873">
            <div className="inline-block px-4 py-1.5 bg-[#6366f1]/10 rounded-full text-[#6366f1] font-medium text-sm mb-6" data-id="element-874">
              Pre-Seed Round • $100K
            </div>
            <h1 className="text-5xl font-bold text-gray-900 mb-6" data-id="element-875">
              UseGigi.ai
            </h1>
            <p className="text-3xl text-gray-900 font-bold mb-4 leading-tight" data-id="element-876">
              Turning B2B Outreach from Spam
              <br data-id="element-877" />
              into Conversations That Convert
            </p>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8" data-id="element-878">
              The first end-to-end AI SDR platform that combines behavioral
              psychology with automation—delivering 5x higher reply rates than
              traditional tools while replacing a $50K+ fragmented tech stack.
            </p>
            <div className="flex justify-center gap-8 mt-8" data-id="element-879">
              <div className="text-center" data-id="element-880">
                <div className="text-3xl font-bold text-[#6366f1]" data-id="element-881">20-27%</div>
                <div className="text-sm text-gray-600" data-id="element-882">Reply Rate</div>
                <div className="text-xs text-gray-500" data-id="element-883">
                  (vs 4-5% industry avg)
                </div>
              </div>
              <div className="text-center" data-id="element-884">
                <div className="text-3xl font-bold text-[#6366f1]" data-id="element-885">3x</div>
                <div className="text-sm text-gray-600" data-id="element-886">Meeting Bookings</div>
                <div className="text-xs text-gray-500" data-id="element-887">(proven results)</div>
              </div>
              <div className="text-center" data-id="element-888">
                <div className="text-3xl font-bold text-[#6366f1]" data-id="element-889">1</div>
                <div className="text-sm text-gray-600" data-id="element-890">Platform</div>
                <div className="text-xs text-gray-500" data-id="element-891">
                  (replaces 5-7 tools)
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Problem Section */}
      <section className="py-16 bg-gray-50" data-id="element-892">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-893">
          <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-894">The Problem</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-895">
            <ProblemCard title="Manual Chaos" description="SDRs spend 80% of time on research and data entry, not selling" data-id="element-896" />
            <ProblemCard title="Generic Outreach" description="Mass personalization tools still feel robotic—4-5% reply rates prove it" data-id="element-897" />
            <ProblemCard title="Fragmented Stack" description="Teams juggle 5-7 tools for prospecting, messaging, and follow-ups" data-id="element-898" />
          </div>
        </div>
      </section>
      {/* Solution Section */}
      <section className="py-16 bg-white" data-id="element-899">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-900">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-901">
            What is UseGigi.ai
          </h2>
          <p className="text-xl text-gray-600 mb-8" data-id="element-902">
            An end-to-end AI SDR platform that goes from{' '}
            <strong data-id="element-903">natural language onboarding</strong> →
            <strong data-id="element-904"> ICP definition</strong> →{' '}
            <strong data-id="element-905">LinkedIn data scraping</strong> →
            <strong data-id="element-906"> psychographic profiling</strong> →{' '}
            <strong data-id="element-907">AI-generated messaging</strong> →
            <strong data-id="element-908"> automated outreach + follow-ups</strong>.
          </p>
          <div className="bg-[#6366f1]/5 rounded-xl p-8 mb-8" data-id="element-909">
            <h3 className="text-xl font-semibold text-gray-900 mb-6" data-id="element-910">
              The Gigi Difference: Why This Matters
            </h3>
            <div className="mb-8" data-id="element-911">
              <p className="text-lg text-gray-700 mb-4" data-id="element-912">
                <strong data-id="element-913">
                  Every competitor treats AI sales tools as either data
                  enrichment OR message generation OR automation.
                </strong>{' '}
                Gigi is the first platform that combines all three with
                behavioral psychology—creating a system that thinks like a top
                SDR, not just a chatbot.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-914">
              <FeatureItem title="Built by People Who Actually Sell" description="Not theoretical—battle-tested daily in Set-Sell.com's real client campaigns. Every feature solves a problem we've personally hit 1000+ times." data-id="element-915" />
              <FeatureItem title="Psychology-First, Not Template-First" description="Analyzes how prospects think and communicate before crafting messages. This is why we hit 20-27% reply rates vs. industry's 4-5%." data-id="element-916" />
              <FeatureItem title="Chat Interface = Zero Learning Curve" description="No complex dashboards or CSV uploads. Talk to Gigi like you'd brief a human SDR. This makes enterprise-grade AI accessible to SMBs." data-id="element-917" />
              <FeatureItem title="The Only True End-to-End Solution" description="From 'who should I target?' to 'meeting booked'—one platform, one workflow. Competitors force you to stitch together 5-7 tools." data-id="element-918" />
            </div>
            <div className="mt-8 bg-white rounded-lg p-6 border-2 border-[#6366f1]" data-id="element-919">
              <p className="text-gray-900 font-semibold text-lg mb-2" data-id="element-920">
                The Core Insight:
              </p>
              <p className="text-gray-700" data-id="element-921">
                Most AI sales tools optimize for <em data-id="element-922">efficiency</em>. Gigi
                optimizes for <strong data-id="element-923">effectiveness</strong>—understanding that
                a 27% reply rate with 100 prospects beats a 5% reply rate with
                1000 prospects. This changes the unit economics of B2B sales.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Traction Section */}
      <section className="py-16 bg-gray-50" data-id="element-924">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-925">
          <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-926">
            Traction & Current Status
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8" data-id="element-927">
            <MetricCard number="6" label="Months in Development" data-id="element-928" />
            <MetricCard number="1,335" label="Real Conversations Generated" data-id="element-929" />
            <MetricCard number="3x" label="Increase in Meeting Bookings" data-id="element-930" />
            <MetricCard number="20-27%" label="Reply Rate (vs 4-5% baseline)" data-id="element-931" />
          </div>
          <div className="bg-white rounded-xl p-6 border border-gray-200" data-id="element-932">
            <h3 className="font-semibold text-gray-900 mb-3" data-id="element-933">
              Current Progress
            </h3>
            <ul className="space-y-2 text-gray-700" data-id="element-934">
              <li data-id="element-935">
                ✓ <strong data-id="element-936">Beta version live</strong> in{' '}
                <a href="https://set-sell.com" target="_blank" rel="noopener noreferrer" className="text-[#6366f1] hover:underline" data-id="element-937">
                  Set-Sell.com
                </a>{' '}
                agency operations
              </li>
              <li data-id="element-938">
                ✓{' '}
                <strong data-id="element-939">
                  17,512 invites sent, 5,173 accepted (29.5%), 1,335 responses
                  (25.8%)
                </strong>{' '}
                - proven beta results
              </li>
              <li data-id="element-940">
                ✓{' '}
                <strong data-id="element-941">
                  End-to-end automated personalized LinkedIn sequences live
                </strong>
              </li>
              <li data-id="element-942">
                ✓ <strong data-id="element-943">Proven results:</strong> 3x meeting bookings, 20-27%
                reply rates
              </li>
              <li data-id="element-944">
                ✓ <strong data-id="element-945">Team established:</strong> Venezuela dev team +
                founders (Lucian, Irina)
              </li>
            </ul>
          </div>
        </div>
      </section>
      {/* Market Landscape Section */}
      <section className="py-16 bg-white" data-id="element-946">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-947">
          <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-948">
            Market Landscape
          </h2>
          {/* Market Overview */}
          <div className="bg-[#6366f1]/5 rounded-xl p-8 mb-8" data-id="element-949">
            <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-950">
              The Fragmented Market Reality
            </h3>
            <p className="text-gray-700 mb-6" data-id="element-951">
              The AI sales automation space has exploded with $3.5B+ invested in
              2024, but the market remains fragmented into three disconnected
              categories:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-952">
              <div className="bg-white rounded-lg p-6 border border-gray-200" data-id="element-953">
                <h4 className="font-semibold text-gray-900 mb-2" data-id="element-954">
                  Data Enrichment
                </h4>
                <p className="text-sm text-gray-600 mb-3" data-id="element-955">
                  Clay, Apollo, LeadIQ
                </p>
                <p className="text-sm text-gray-700" data-id="element-956">
                  Great at finding prospects, but require manual export and
                  separate tools for outreach
                </p>
              </div>
              <div className="bg-white rounded-lg p-6 border border-gray-200" data-id="element-957">
                <h4 className="font-semibold text-gray-900 mb-2" data-id="element-958">
                  AI Copy Assistants
                </h4>
                <p className="text-sm text-gray-600 mb-3" data-id="element-959">
                  Lavender, Lyne, Regie
                </p>
                <p className="text-sm text-gray-700" data-id="element-960">
                  Help write better messages, but don't handle prospecting or
                  automation
                </p>
              </div>
              <div className="bg-white rounded-lg p-6 border border-gray-200" data-id="element-961">
                <h4 className="font-semibold text-gray-900 mb-2" data-id="element-962">
                  Outreach Automation
                </h4>
                <p className="text-sm text-gray-600 mb-3" data-id="element-963">
                  SmartLead, Outplay, Amplemarket
                </p>
                <p className="text-sm text-gray-700" data-id="element-964">
                  Automate sending, but use generic personalization (just
                  name/company swaps)
                </p>
              </div>
            </div>
            <div className="bg-white rounded-lg p-6 border-2 border-[#6366f1]" data-id="element-965">
              <p className="text-gray-900 font-semibold text-lg mb-2" data-id="element-966">
                The Result?
              </p>
              <p className="text-gray-700" data-id="element-967">
                Sales teams juggle 5-7 tools, spending 80% of their time on
                setup and data transfer instead of selling.{' '}
                <strong data-id="element-968">
                  UseGigi fills the missing gap between data intelligence,
                  personalization, and outreach automation—a "ChatGPT for SDRs."
                </strong>
              </p>
            </div>
          </div>
          {/* Competitive Positioning */}
          <div className="mb-8" data-id="element-969">
            <h3 className="text-xl font-semibold text-gray-900 mb-6" data-id="element-970">
              How UseGigi Compares
            </h3>
            <div className="space-y-4" data-id="element-971">
              <CompetitorComparison competitor="11x.ai" competitorUrl="https://11x.ai" stage="Seed" strength="Autonomous 'AI employee' model for SDR tasks" gap="No LinkedIn Sales Navigator integration or psychographic profiling. Focuses on email, not LinkedIn where B2B buyers actually engage." gigiAdvantage="Gigi combines LinkedIn automation + personality assessment + chat onboarding in one flow" data-id="element-972" />
              <CompetitorComparison competitor="Humanlinker" competitorUrl="https://humanlinker.com" stage="Seed" strength="DISC personality profiling for sales outreach" gap="Requires manual data input. No automated scraping or end-to-end sequence automation." gigiAdvantage="Gigi automatically extracts personality insights from LinkedIn and executes the entire outreach sequence" data-id="element-973" />
              <CompetitorComparison competitor="Amplemarket" competitorUrl="https://amplemarket.com" stage="Series A" strength="Full-cycle outbound with data enrichment + sequences" gap="Generic personalization (name/company variables only). No AI chat onboarding or psychographic analysis." gigiAdvantage="Gigi uses behavioral psychology to craft messages that resonate with how each prospect actually thinks and communicates" data-id="element-974" />
              <CompetitorComparison competitor="Clay + Smartlead" competitorUrl="https://clay.com" stage="Series A (combined)" strength="Best-in-class data enrichment + deliverability" gap="Requires stitching together 2-3 tools manually. No unified workflow or AI-guided setup." gigiAdvantage="Gigi handles everything from 'who should I target?' to 'meeting booked' in one conversational interface" data-id="element-975" />
            </div>
          </div>
          {/* Market Opportunity */}
          <div className="bg-white rounded-xl p-6 border border-gray-200 mb-6" data-id="element-976">
            <h3 className="font-semibold text-gray-900 mb-4" data-id="element-977">
              The White Space Opportunity
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-978">
              <div data-id="element-979">
                <h4 className="font-semibold text-gray-900 mb-2" data-id="element-980">
                  What Exists:
                </h4>
                <ul className="space-y-2 text-sm text-gray-700" data-id="element-981">
                  <li data-id="element-982">✓ Tools that find prospects</li>
                  <li data-id="element-983">✓ Tools that write copy</li>
                  <li data-id="element-984">✓ Tools that send messages</li>
                  <li data-id="element-985">✓ Tools that track analytics</li>
                </ul>
              </div>
              <div data-id="element-986">
                <h4 className="font-semibold text-gray-900 mb-2" data-id="element-987">
                  What's Missing:
                </h4>
                <ul className="space-y-2 text-sm text-gray-700" data-id="element-988">
                  <li data-id="element-989">
                    ✗ <strong data-id="element-990">One tool that does it all</strong>
                  </li>
                  <li data-id="element-991">
                    ✗ <strong data-id="element-992">Psychology-based personalization</strong>
                  </li>
                  <li data-id="element-993">
                    ✗ <strong data-id="element-994">Conversational AI onboarding</strong>
                  </li>
                  <li data-id="element-995">
                    ✗ <strong data-id="element-996">LinkedIn-native automation</strong>
                  </li>
                </ul>
              </div>
            </div>
            <div className="mt-6 pt-6 border-t border-gray-200" data-id="element-997">
              <p className="text-gray-700" data-id="element-998">
                <strong data-id="element-999">Market Timing:</strong> Most competitors are Seed to
                Series A stage, validating the category but leaving room for a
                differentiated approach. UseGigi enters at pre-seed with a
                unique value proposition:{' '}
                <strong data-id="element-1000">
                  the only end-to-end AI SDR that combines behavioral psychology
                  with full automation.
                </strong>
              </p>
            </div>
          </div>
          {/* Link to Full Competitive Analysis */}
          <div className="text-center" data-id="element-1001">
            <a href="https://docs.google.com/spreadsheets/d/1RdU2Cag4skoqmQofMB04Hn85S45v6_viCUwT7kcrGzQ/edit?usp=sharing" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-[#6366f1] hover:underline font-medium" data-id="element-1002">
              View Full Competitive Landscape Analysis →
            </a>
          </div>
        </div>
      </section>
      {/* Market Financial Opportunity Section */}
      <section className="py-16 bg-gray-50" data-id="element-1003">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1004">
          <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-1005">
            The Money Talk: Market Size & Validation
          </h2>
          <div className="bg-white rounded-xl p-8 border border-gray-200 mb-8" data-id="element-1006">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-1007">
              <div data-id="element-1008">
                <h3 className="text-2xl font-bold text-[#6366f1] mb-2" data-id="element-1009">
                  $58B → $240B
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-1010">
                  AI Sales & Marketing market growth by 2030 (33% CAGR)
                </p>
                <div className="space-y-3 text-sm text-gray-700" data-id="element-1011">
                  <div className="flex justify-between" data-id="element-1012">
                    <span data-id="element-1013">AI Sales Assistant segment:</span>
                    <span className="font-semibold" data-id="element-1014">$19.6B by 2034</span>
                  </div>
                  <div className="flex justify-between" data-id="element-1015">
                    <span data-id="element-1016">Sales Intelligence segment:</span>
                    <span className="font-semibold" data-id="element-1017">$9B+ by 2030</span>
                  </div>
                </div>
              </div>
              <div className="bg-[#6366f1]/5 rounded-lg p-6" data-id="element-1018">
                <h4 className="font-semibold text-gray-900 mb-3" data-id="element-1019">
                  Translation: This isn't a nice-to-have market. It's a gold
                  rush.
                </h4>
                <p className="text-sm text-gray-700" data-id="element-1020">
                  The category is validated, growing fast, and attracting
                  serious capital. We're not convincing people they need AI
                  sales tools—they're already buying. We're just building the
                  best one.
                </p>
              </div>
            </div>
            <div className="border-t border-gray-200 pt-8" data-id="element-1021">
              <h3 className="text-xl font-semibold text-gray-900 mb-6" data-id="element-1022">
                Proof the Market Pays: Current Players & Their ARR
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6" data-id="element-1023">
                <RevenueCard company="Apollo.io" arr="$150M+" description="Market leader in data enrichment" data-id="element-1024" />
                <RevenueCard company="Clay.com" arr="~$30M" description="Data enrichment darling" data-id="element-1025" />
                <RevenueCard company="Outplay.ai" arr="~$20M" description="Multi-channel automation" data-id="element-1026" />
                <RevenueCard company="SmartLead.ai" arr="$10-14M" description="Email deliverability focus" data-id="element-1027" />
                <RevenueCard company="Regie.ai" arr="~$8M" description="AI copywriting assistant" data-id="element-1028" />
                <RevenueCard company="11x.ai" arr="$2-10M" description="Autonomous AI SDR (newer entrant)" data-id="element-1029" />
              </div>
              <div className="bg-[#d5ff00]/10 rounded-lg p-6 border border-[#d5ff00]/30" data-id="element-1030">
                <p className="text-gray-900 font-semibold mb-2" data-id="element-1031">
                  The Bottom Line:
                </p>
                <p className="text-gray-700" data-id="element-1032">
                  These numbers prove strong market demand and serious capital
                  flowing into AI-driven outbound automation. Even early-stage
                  players are hitting multi-million ARR quickly. As the market
                  consolidates,{' '}
                  <strong data-id="element-1033">
                    UseGigi's end-to-end automation model positions it to
                    compete for a significant share of this rapidly scaling,
                    multi-billion-dollar industry
                  </strong>
                  — already validated by well-funded competitors.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Opportunity Section */}
      <section className="py-16 bg-gray-50" data-id="element-1034">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1035">
          <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-1036">Why Now</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1037">
            <OpportunityCard icon={<TrendingUp data-id="element-1039" />} title="AI Evolution" description="LLMs now understand context and nuance—enabling true personalization at scale" data-id="element-1038" />
            <OpportunityCard icon={<Target data-id="element-1041" />} title="Sales Efficiency Crisis" description="Companies cutting SDR headcount but need more pipeline—AI automation is the answer" data-id="element-1040" />
            <OpportunityCard icon={<Zap data-id="element-1043" />} title="Market Timing" description="$3.5B+ invested in sales AI tools in 2024—category is validated and growing" data-id="element-1042" />
          </div>
        </div>
      </section>
      {/* Business Case Section */}
      <section className="py-16 bg-gray-50" data-id="element-1044">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1045">
          <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-1046">
            📊 Business Case
          </h2>
          <div className="bg-white rounded-xl p-8 border border-gray-200 mb-6" data-id="element-1047">
            <p className="text-lg text-gray-700 mb-6" data-id="element-1048">
              UseGigi.ai's pay-as-you-scale model charges{' '}
              <strong data-id="element-1049">$1 per qualified prospect</strong>, with clients averaging
              1,000 prospects/month and achieving a 25% engagement rate. With
              80% gross margins and rapid early adoption, UseGigi can grow
              aggressively in the first year (30% MoM) and sustain steady
              expansion (10% MoM) in the second, reaching multi-million ARR with
              minimal capital.
            </p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6" data-id="element-1050">
              <div className="bg-[#6366f1]/5 rounded-lg p-4 text-center" data-id="element-1051">
                <div className="text-2xl font-bold text-[#6366f1] mb-1" data-id="element-1052">$1</div>
                <div className="text-xs text-gray-600" data-id="element-1053">Price per prospect</div>
              </div>
              <div className="bg-[#6366f1]/5 rounded-lg p-4 text-center" data-id="element-1054">
                <div className="text-2xl font-bold text-[#6366f1] mb-1" data-id="element-1055">
                  1,000
                </div>
                <div className="text-xs text-gray-600" data-id="element-1056">
                  Avg prospects/client
                </div>
              </div>
              <div className="bg-[#6366f1]/5 rounded-lg p-4 text-center" data-id="element-1057">
                <div className="text-2xl font-bold text-[#6366f1] mb-1" data-id="element-1058">
                  25%
                </div>
                <div className="text-xs text-gray-600" data-id="element-1059">Engagement rate</div>
              </div>
              <div className="bg-[#6366f1]/5 rounded-lg p-4 text-center" data-id="element-1060">
                <div className="text-2xl font-bold text-[#6366f1] mb-1" data-id="element-1061">
                  80%
                </div>
                <div className="text-xs text-gray-600" data-id="element-1062">Gross margin</div>
              </div>
            </div>
            <button onClick={() => setIsBusinessCaseOpen(true)} className="w-full py-4 bg-[#6366f1] text-white rounded-lg hover:bg-[#5457e5] font-semibold flex items-center justify-center gap-2 transition-colors" data-id="element-1063">
              View 24-Month Financial Projections
              <ChevronRight className="w-5 h-5" data-id="element-1064" />
            </button>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1065">
            <div className="bg-white rounded-lg p-6 border border-gray-200 text-center" data-id="element-1066">
              <div className="text-3xl font-bold text-[#6366f1] mb-2" data-id="element-1067">
                $7.32M
              </div>
              <div className="text-sm text-gray-600 font-medium" data-id="element-1068">
                ARR at Month 24
              </div>
            </div>
            <div className="bg-white rounded-lg p-6 border border-gray-200 text-center" data-id="element-1069">
              <div className="text-3xl font-bold text-[#6366f1] mb-2" data-id="element-1070">
                $4.9M
              </div>
              <div className="text-sm text-gray-600 font-medium" data-id="element-1071">
                Annual Gross Profit
              </div>
            </div>
            <div className="bg-white rounded-lg p-6 border border-gray-200 text-center" data-id="element-1072">
              <div className="text-3xl font-bold text-[#6366f1] mb-2" data-id="element-1073">610</div>
              <div className="text-sm text-gray-600 font-medium" data-id="element-1074">
                Active Clients
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Business Case Modal */}
      {isBusinessCaseOpen && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4 overflow-y-auto" data-id="element-1075">
          <div className="bg-white rounded-xl max-w-5xl w-full my-8 relative max-h-[90vh] overflow-y-auto" data-id="element-1076">
            <div className="sticky top-0 bg-white border-b border-gray-200 px-8 py-6 flex justify-between items-center" data-id="element-1077">
              <h3 className="text-2xl font-bold text-gray-900" data-id="element-1078">
                📊 Business Case (24-Month Projection)
              </h3>
              <button onClick={() => setIsBusinessCaseOpen(false)} className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-1079">
                <X className="w-6 h-6" data-id="element-1080" />
              </button>
            </div>
            <div className="p-8" data-id="element-1081">
              <p className="text-lg text-gray-700 mb-8" data-id="element-1082">
                UseGigi.ai's pay-as-you-scale model charges{' '}
                <strong data-id="element-1083">$1 per qualified prospect</strong>, with clients
                averaging 1,000 prospects/month and achieving a 25% engagement
                rate. With 80% gross margins and rapid early adoption, UseGigi
                can grow aggressively in the first year (30% MoM) and sustain
                steady expansion (10% MoM) in the second, reaching multi-million
                ARR with minimal capital.
              </p>
              <div className="bg-[#6366f1]/5 rounded-xl p-6 mb-8" data-id="element-1084">
                <h4 className="font-semibold text-gray-900 mb-4" data-id="element-1085">
                  Key Assumptions
                </h4>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-1086">
                  <div className="bg-white rounded-lg p-4" data-id="element-1087">
                    <div className="text-sm text-gray-600 mb-1" data-id="element-1088">
                      Price per prospect
                    </div>
                    <div className="text-xl font-bold text-[#6366f1]" data-id="element-1089">$1</div>
                  </div>
                  <div className="bg-white rounded-lg p-4" data-id="element-1090">
                    <div className="text-sm text-gray-600 mb-1" data-id="element-1091">
                      Avg prospects/client/month
                    </div>
                    <div className="text-xl font-bold text-[#6366f1]" data-id="element-1092">
                      1,000
                    </div>
                  </div>
                  <div className="bg-white rounded-lg p-4" data-id="element-1093">
                    <div className="text-sm text-gray-600 mb-1" data-id="element-1094">
                      Engagement rate
                    </div>
                    <div className="text-xl font-bold text-[#6366f1]" data-id="element-1095">25%</div>
                  </div>
                  <div className="bg-white rounded-lg p-4" data-id="element-1096">
                    <div className="text-sm text-gray-600 mb-1" data-id="element-1097">
                      Gross margin
                    </div>
                    <div className="text-xl font-bold text-[#6366f1]" data-id="element-1098">80%</div>
                  </div>
                  <div className="bg-white rounded-lg p-4" data-id="element-1099">
                    <div className="text-sm text-gray-600 mb-1" data-id="element-1100">
                      Starting clients (Month 1)
                    </div>
                    <div className="text-xl font-bold text-[#6366f1]" data-id="element-1101">10</div>
                  </div>
                  <div className="bg-white rounded-lg p-4" data-id="element-1102">
                    <div className="text-sm text-gray-600 mb-1" data-id="element-1103">
                      Growth rate
                    </div>
                    <div className="text-xl font-bold text-[#6366f1]" data-id="element-1104">
                      30% → 10%
                    </div>
                    <div className="text-xs text-gray-500 mt-1" data-id="element-1105">
                      Yr 1 → Yr 2
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-8 overflow-x-auto" data-id="element-1106">
                <table className="w-full border-collapse" data-id="element-1107">
                  <thead data-id="element-1108">
                    <tr className="bg-[#6366f1] text-white" data-id="element-1109">
                      <th className="px-4 py-3 text-left rounded-tl-lg" data-id="element-1110">
                        Month
                      </th>
                      <th className="px-4 py-3 text-right" data-id="element-1111">Active Clients</th>
                      <th className="px-4 py-3 text-right" data-id="element-1112">Monthly Revenue</th>
                      <th className="px-4 py-3 text-right" data-id="element-1113">
                        Gross Profit (80%)
                      </th>
                      <th className="px-4 py-3 text-right rounded-tr-lg" data-id="element-1114">
                        ARR
                      </th>
                    </tr>
                  </thead>
                  <tbody data-id="element-1115">
                    <tr className="border-b border-gray-200 hover:bg-gray-50" data-id="element-1116">
                      <td className="px-4 py-3 font-semibold" data-id="element-1117">1</td>
                      <td className="px-4 py-3 text-right" data-id="element-1118">10</td>
                      <td className="px-4 py-3 text-right" data-id="element-1119">$10K</td>
                      <td className="px-4 py-3 text-right text-[#6366f1] font-semibold" data-id="element-1120">
                        $8K
                      </td>
                      <td className="px-4 py-3 text-right font-semibold" data-id="element-1121">
                        $120K
                      </td>
                    </tr>
                    <tr className="border-b border-gray-200 hover:bg-gray-50" data-id="element-1122">
                      <td className="px-4 py-3 font-semibold" data-id="element-1123">6</td>
                      <td className="px-4 py-3 text-right" data-id="element-1124">37</td>
                      <td className="px-4 py-3 text-right" data-id="element-1125">$37K</td>
                      <td className="px-4 py-3 text-right text-[#6366f1] font-semibold" data-id="element-1126">
                        $29.6K
                      </td>
                      <td className="px-4 py-3 text-right font-semibold" data-id="element-1127">
                        $444K
                      </td>
                    </tr>
                    <tr className="border-b border-gray-200 hover:bg-gray-50" data-id="element-1128">
                      <td className="px-4 py-3 font-semibold" data-id="element-1129">12</td>
                      <td className="px-4 py-3 text-right" data-id="element-1130">190</td>
                      <td className="px-4 py-3 text-right" data-id="element-1131">$190K</td>
                      <td className="px-4 py-3 text-right text-[#6366f1] font-semibold" data-id="element-1132">
                        $152K
                      </td>
                      <td className="px-4 py-3 text-right font-semibold" data-id="element-1133">
                        $2.28M
                      </td>
                    </tr>
                    <tr className="border-b border-gray-200 hover:bg-gray-50" data-id="element-1134">
                      <td className="px-4 py-3 font-semibold" data-id="element-1135">18</td>
                      <td className="px-4 py-3 text-right" data-id="element-1136">339</td>
                      <td className="px-4 py-3 text-right" data-id="element-1137">$339K</td>
                      <td className="px-4 py-3 text-right text-[#6366f1] font-semibold" data-id="element-1138">
                        $271K
                      </td>
                      <td className="px-4 py-3 text-right font-semibold" data-id="element-1139">
                        $4.06M
                      </td>
                    </tr>
                    <tr className="bg-[#6366f1]/5 hover:bg-[#6366f1]/10" data-id="element-1140">
                      <td className="px-4 py-3 font-bold" data-id="element-1141">24</td>
                      <td className="px-4 py-3 text-right font-bold" data-id="element-1142">610</td>
                      <td className="px-4 py-3 text-right font-bold" data-id="element-1143">$610K</td>
                      <td className="px-4 py-3 text-right text-[#6366f1] font-bold" data-id="element-1144">
                        $488K
                      </td>
                      <td className="px-4 py-3 text-right font-bold text-lg" data-id="element-1145">
                        $7.32M
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="bg-[#d5ff00]/10 rounded-lg p-6 border border-[#d5ff00]/30" data-id="element-1146">
                <p className="text-gray-900 font-semibold mb-2" data-id="element-1147">Summary</p>
                <p className="text-gray-700" data-id="element-1148">
                  Over 24 months, UseGigi.ai can scale from 10 to 600+ clients,
                  reaching <strong data-id="element-1149">$7.32M ARR</strong> and{' '}
                  <strong data-id="element-1150">~$4.9M annual gross profit</strong> with only $100K in
                  pre-seed capital. The combination of transparent pricing, high
                  engagement rates, and strong margins gives a clear path to
                  profitability and investor returns within two years.
                </p>
              </div>
            </div>
          </div>
        </div>}
      {/* Business Model Section */}
      <section className="py-16 bg-white" data-id="element-1151">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1152">
          <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-1153">
            Business Model & Go-To-Market
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1154">
            <div className="bg-[#6366f1]/5 rounded-xl p-6" data-id="element-1155">
              <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-1156">
                Revenue Model
              </h3>
              <ul className="space-y-3 text-gray-700" data-id="element-1157">
                <li data-id="element-1158">
                  • <strong data-id="element-1159">Freemium:</strong> 20 credits/month free (1
                  campaign)
                </li>
                <li data-id="element-1160">
                  • <strong data-id="element-1161">Pro Plan:</strong> $99/month (100 credits, unlimited
                  campaigns)
                </li>
                <li data-id="element-1162">
                  • <strong data-id="element-1163">Enterprise:</strong> Custom pricing for teams 10+
                </li>
                <li data-id="element-1164">
                  • <strong data-id="element-1165">Target:</strong> $2M+ ARR within 12 months, scaling
                  to $7M+ by month 24
                </li>
              </ul>
            </div>
            <div className="bg-[#6366f1]/5 rounded-xl p-6" data-id="element-1166">
              <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-1167">
                Go-To-Market Strategy
              </h3>
              <ul className="space-y-3 text-gray-700" data-id="element-1168">
                <li data-id="element-1169">
                  • <strong data-id="element-1170">Phase 1:</strong> Walk the talk: running gigi
                  campaigns to attract users
                </li>
                <li data-id="element-1171">
                  • <strong data-id="element-1172">Phase 2:</strong> Launch on Product Hunt and similar
                </li>
                <li data-id="element-1173">
                  • <strong data-id="element-1174">Phase 3:</strong> Direct B2B sales to SMBs and
                  startups
                </li>
                <li data-id="element-1175">
                  • <strong data-id="element-1176">Phase 4:</strong> Enterprise expansion
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Investment Opportunity Section */}
      <section className="py-16 bg-gradient-to-b from-[#6366f1] to-[#5457e5] text-white" data-id="element-1177">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1178">
          <div className="text-center mb-12" data-id="element-1179">
            <h2 className="text-4xl font-bold mb-6" data-id="element-1180">
              💰 Investment Opportunity
            </h2>
            <p className="text-xl opacity-95 max-w-3xl mx-auto leading-relaxed" data-id="element-1181">
              We are raising <strong data-id="element-1182">$100,000 pre-seed</strong> to bring
              UseGigi.ai live and accelerate go-to-market. In return, investors
              receive <strong data-id="element-1183">10% equity at a $1M post-money valuation</strong>,
              plus a performance-based option to invest an additional $100,000
              for another 10% at the same valuation after 6 months — if the
              business plan milestones are achieved.
            </p>
          </div>
          {/* Milestone Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-1184">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20" data-id="element-1185">
              <div className="flex items-start justify-between mb-4" data-id="element-1186">
                <div data-id="element-1187">
                  <div className="text-[#d5ff00] font-bold text-sm mb-2" data-id="element-1188">
                    PHASE 1: LAUNCH
                  </div>
                  <div className="text-2xl font-bold mb-1" data-id="element-1189">0–3 Months</div>
                </div>
                <div className="bg-[#d5ff00] text-gray-900 px-3 py-1 rounded-full text-sm font-bold" data-id="element-1190">
                  NOW
                </div>
              </div>
              <div className="space-y-4" data-id="element-1191">
                <div data-id="element-1192">
                  <div className="text-sm opacity-75 mb-1" data-id="element-1193">Objective</div>
                  <div className="font-semibold" data-id="element-1194">
                    Complete self-service AI SDR platform & onboard 10 clients
                  </div>
                </div>
                <div className="pt-4 border-t border-white/20" data-id="element-1195">
                  <div className="text-sm opacity-75 mb-1" data-id="element-1196">
                    Investor Opportunity
                  </div>
                  <div className="text-xl font-bold text-[#d5ff00]" data-id="element-1197">
                    $100K for 10% equity
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20" data-id="element-1198">
              <div className="flex items-start justify-between mb-4" data-id="element-1199">
                <div data-id="element-1200">
                  <div className="text-[#d5ff00] font-bold text-sm mb-2" data-id="element-1201">
                    PHASE 2: TRACTION
                  </div>
                  <div className="text-2xl font-bold mb-1" data-id="element-1202">4–6 Months</div>
                </div>
                <div className="bg-white/20 text-white px-3 py-1 rounded-full text-sm font-bold" data-id="element-1203">
                  OPTION
                </div>
              </div>
              <div className="space-y-4" data-id="element-1204">
                <div data-id="element-1205">
                  <div className="text-sm opacity-75 mb-1" data-id="element-1206">Objective</div>
                  <div className="font-semibold" data-id="element-1207">
                    Reach 37+ clients and $37K MRR
                  </div>
                </div>
                <div className="pt-4 border-t border-white/20" data-id="element-1208">
                  <div className="text-sm opacity-75 mb-1" data-id="element-1209">
                    Additional Investment Option
                  </div>
                  <div className="text-xl font-bold text-[#d5ff00]" data-id="element-1210">
                    +$100K for +10% equity at same valuation
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Use of Funds */}
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20" data-id="element-1211">
            <h3 className="text-2xl font-bold mb-6 text-center" data-id="element-1212">
              Use of Funds
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1213">
              <div className="text-center" data-id="element-1214">
                <div className="w-16 h-16 bg-[#d5ff00] rounded-full flex items-center justify-center mx-auto mb-4 text-4xl" data-id="element-1215">
                  🚀
                </div>
                <div className="text-3xl font-bold mb-2" data-id="element-1216">50%</div>
                <div className="text-sm opacity-90" data-id="element-1217">Product finalization</div>
                <div className="text-xs opacity-75 mt-1" data-id="element-1218">
                  (AI automation & integrations)
                </div>
              </div>
              <div className="text-center" data-id="element-1219">
                <div className="w-16 h-16 bg-[#d5ff00] rounded-full flex items-center justify-center mx-auto mb-4 text-4xl" data-id="element-1220">
                  📈
                </div>
                <div className="text-3xl font-bold mb-2" data-id="element-1221">40%</div>
                <div className="text-sm opacity-90" data-id="element-1222">
                  Marketing & client acquisition
                </div>
                <div className="text-xs opacity-75 mt-1" data-id="element-1223">
                  (Go-to-market execution)
                </div>
              </div>
              <div className="text-center" data-id="element-1224">
                <div className="w-16 h-16 bg-[#d5ff00] rounded-full flex items-center justify-center mx-auto mb-4 text-4xl" data-id="element-1225">
                  ⚙️
                </div>
                <div className="text-3xl font-bold mb-2" data-id="element-1226">10%</div>
                <div className="text-sm opacity-90" data-id="element-1227">Infrastructure & ops</div>
                <div className="text-xs opacity-75 mt-1" data-id="element-1228">
                  (Systems & support)
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Team Section */}
      <section className="py-16 bg-white" data-id="element-1229">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1230">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center" data-id="element-1231">
            Founding Team
          </h2>
          {/* Track Record Section */}
          <div className="bg-gradient-to-r from-[#6366f1]/5 to-[#d5ff00]/5 rounded-xl p-8 mb-12 border border-[#6366f1]/20" data-id="element-1232">
            <div className="flex items-start gap-4" data-id="element-1233">
              <div className="w-12 h-12 bg-[#6366f1] rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-1234">
                <TrendingUp className="w-6 h-6 text-white" data-id="element-1235" />
              </div>
              <div data-id="element-1236">
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-1237">
                  Proven Track Record: Previous Exit
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-1238">
                  The founding team has successfully built and exited a previous
                  venture, demonstrating their ability to execute, scale, and
                  deliver returns to investors. This experience informs
                  UseGigi's strategic approach and go-to-market execution.
                </p>
                <div className="inline-flex items-center gap-2 bg-white rounded-lg px-4 py-2 border border-gray-200" data-id="element-1239">
                  <div className="w-2 h-2 bg-green-500 rounded-full" data-id="element-1240"></div>
                  <span className="text-sm font-semibold text-gray-900" data-id="element-1241">
                    Successful Exits Achieved
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1242">
            <TeamMember name="Irina" role="Founder & CEO" description="17+ years in B2B sales, over 50 scaled projects. Runs Set-Sell.com agency where Gigi is battle-tested daily." image="https://uploadthingy.s3.us-west-1.amazonaws.com/uy5NWm7gwFbrAv2AbUN2KJ/irina_lam.jpg" data-id="element-1243" />
            <TeamMember name="Lucian" role="Co-Founder & COO" description="20 years in tech, sales, staffing and recruiting, startups and automation." image="https://uploadthingy.s3.us-west-1.amazonaws.com/98HoHnaDpqofrTai9w3RpF/lucian_cretu.jpg" data-id="element-1244" />
            <TeamMember name="Dev Team" role="Engineering" description="Various independent contractors with expertise in AI, automation and scalable systems." data-id="element-1245" />
          </div>
        </div>
      </section>
      {/* Footer */}
      <section className="py-12 bg-gray-900 text-white" data-id="element-1246">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1247">
          <h3 className="text-2xl font-bold mb-4" data-id="element-1248">Ready to Learn More?</h3>
          <p className="text-gray-400 mb-6" data-id="element-1249">
            Contact us to schedule a demo or discuss investment opportunities
          </p>
          <a href="mailto:usegigi@usegigi.ai" className="inline-block px-8 py-3 bg-[#d5ff00] text-gray-900 rounded-lg font-semibold hover:bg-[#c0e600] transition-colors" data-id="element-1250">
            Get in Touch
          </a>
        </div>
      </section>
    </div>;
};
const ProblemCard = ({
  title,
  description
}: {
  title: string;
  description: string;
}) => <div className="bg-white rounded-lg p-6 border border-gray-200" data-id="element-1251">
    <h3 className="font-semibold text-gray-900 mb-2" data-id="element-1252">{title}</h3>
    <p className="text-gray-600" data-id="element-1253">{description}</p>
  </div>;
const FeatureItem = ({
  title,
  description
}: {
  title: string;
  description: string;
}) => <div data-id="element-1254">
    <h4 className="font-semibold text-gray-900 mb-1" data-id="element-1255">{title}</h4>
    <p className="text-gray-600 text-sm" data-id="element-1256">{description}</p>
  </div>;
const MetricCard = ({
  number,
  label
}: {
  number: string;
  label: string;
}) => <div className="bg-white rounded-lg p-6 border border-gray-200 text-center" data-id="element-1257">
    <div className="text-3xl font-bold text-[#6366f1] mb-2" data-id="element-1258">{number}</div>
    <div className="text-sm text-gray-600" data-id="element-1259">{label}</div>
  </div>;
const CompetitorComparison = ({
  competitor,
  competitorUrl,
  stage,
  strength,
  gap,
  gigiAdvantage
}: {
  competitor: string;
  competitorUrl: string;
  stage: string;
  strength: string;
  gap: string;
  gigiAdvantage: string;
}) => <div className="bg-gray-50 rounded-lg p-6 border border-gray-200" data-id="element-1260">
    <div className="flex items-start justify-between mb-3" data-id="element-1261">
      <div data-id="element-1262">
        <a href={competitorUrl} target="_blank" rel="noopener noreferrer" className="text-lg font-semibold text-[#6366f1] hover:underline" data-id="element-1263">
          {competitor}
        </a>
        <span className="ml-3 text-sm text-gray-500" data-id="element-1264">({stage})</span>
      </div>
    </div>
    <div className="space-y-3 text-sm" data-id="element-1265">
      <div data-id="element-1266">
        <span className="font-semibold text-gray-900" data-id="element-1267">Their Strength: </span>
        <span className="text-gray-700" data-id="element-1268">{strength}</span>
      </div>
      <div data-id="element-1269">
        <span className="font-semibold text-gray-900" data-id="element-1270">The Gap: </span>
        <span className="text-gray-700" data-id="element-1271">{gap}</span>
      </div>
      <div className="pt-2 border-t border-gray-200" data-id="element-1272">
        <span className="font-semibold text-[#6366f1]" data-id="element-1273">Gigi's Advantage: </span>
        <span className="text-gray-700" data-id="element-1274">{gigiAdvantage}</span>
      </div>
    </div>
  </div>;
const CompetitorInsight = ({
  competitor,
  competitorUrl,
  gap
}: {
  competitor: string;
  competitorUrl: string;
  gap: string;
}) => <div className="bg-white rounded-lg p-4 border border-gray-200" data-id="element-1275">
    <div className="font-semibold text-gray-900 mb-1" data-id="element-1276">
      <a href={competitorUrl} target="_blank" rel="noopener noreferrer" className="text-[#6366f1] hover:underline" data-id="element-1277">
        {competitor}
      </a>
    </div>
    <div className="text-sm text-gray-600" data-id="element-1278">{gap}</div>
  </div>;
const OpportunityCard = ({
  icon,
  title,
  description
}: {
  icon: React.ReactNode;
  title: string;
  description: string;
}) => <div className="bg-white rounded-lg p-6 border border-gray-200" data-id="element-1279">
    <div className="w-12 h-12 bg-[#6366f1]/10 rounded-lg flex items-center justify-center mb-4 text-[#6366f1]" data-id="element-1280">
      {icon}
    </div>
    <h3 className="font-semibold text-gray-900 mb-2" data-id="element-1281">{title}</h3>
    <p className="text-gray-600 text-sm" data-id="element-1282">{description}</p>
  </div>;
const TeamMember = ({
  name,
  role,
  description,
  image
}: {
  name: string;
  role: string;
  description: string;
  image?: string;
}) => <div className="text-center" data-id="element-1283">
    {image ? <img src={image} alt={name} className="w-20 h-20 rounded-full mx-auto mb-4 object-cover" data-id="element-1284" /> : <div className="w-20 h-20 bg-[#6366f1]/10 rounded-full mx-auto mb-4 flex items-center justify-center" data-id="element-1285">
        <Users className="w-10 h-10 text-[#6366f1]" data-id="element-1286" />
      </div>}
    <h3 className="font-semibold text-gray-900 mb-1" data-id="element-1287">{name}</h3>
    <div className="text-sm text-[#6366f1] mb-2" data-id="element-1288">{role}</div>
    <p className="text-sm text-gray-600" data-id="element-1289">{description}</p>
  </div>;
const RevenueCard = ({
  company,
  arr,
  description
}: {
  company: string;
  arr: string;
  description: string;
}) => <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-1290">
    <div className="flex justify-between items-start mb-2" data-id="element-1291">
      <span className="font-semibold text-gray-900" data-id="element-1292">{company}</span>
      <span className="text-[#6366f1] font-bold text-sm" data-id="element-1293">{arr}</span>
    </div>
    <p className="text-xs text-gray-600" data-id="element-1294">{description}</p>
  </div>;